import {useState, useEffect} from 'react';
import {useMutation, useQueryClient} from "@tanstack/react-query";
import useAbility from "./useAbility";

import {
    createCommentLike,
    createLike,
    createSubCommentLike,
    deleteCommentLike,
    deleteLike, deleteSubCommentLike,
    createForumTopicCommentLike,
    deleteForumTopicCommentLike,
    createTopicLike,
    deleteTopicLike
} from "../api/public-voissa/likes";
import {MEDIA_KEY} from "../api/public-voissa/medias";
import useCurrentUserActionLocked, {ACTION_LOCKED} from "./useCurrentUserActionLocked";

const LIKE_KINDS = {
    MEDIA : "medias",
    STATUS : "status",
    ARTICLE : "articles",
    COMMENT : "comments",
    SUB_COMMENT : "sub_comments",
    TOPIC: "topic",
    TOPIC_COMMENT: "topiccomment"
}

const useLike = ({
    parentKind  = "",
    commentKindParent,
    parentId,
    commentId,
    topicId,
    forumId,
    subCommentId,
    isLike = false,
    contentOwner,
    onSuccess = () =>{},
    onMutate = () =>{},
    onError = () =>{}
}) =>{

    const queryClient = useQueryClient();
    const {can} = useAbility();

    const canLike =  can({ action:'create', subject:'Like' });
    const [isLiked, setIsLiked] = useState(isLike);

    useEffect(() => {
        setIsLiked(isLike);
    }, [isLike]);


    async function handleSuccess (){
        switch (parentKind) {
            case LIKE_KINDS.MEDIA:
                await queryClient.invalidateQueries([MEDIA_KEY, parentId]);
                // await queryClient.invalidateQueries([MEDIAS_KEY]); // pb quand on est sur une page de media trié par like
                break;
            /*case LIKE_KINDS.ARTICLE:
                await queryClient.invalidateQueries([ARTICLE_KEY, parentId]);
                await queryClient.invalidateQueries([USER_ARTICLES_KEY]);
                break;*/
            default:
                break;
        }
        onSuccess();
    }

    function handleError (){
        setIsLiked(!isLiked);
        onError();
    }

    const getMutation = (isLiked) =>{
        const _parentKind = parentKind?.toLowerCase();
        const _commentKindParent = commentKindParent?.toLowerCase();
        switch (_parentKind) {
            case LIKE_KINDS.MEDIA:
                return isLiked ? deleteLike(_parentKind, parentId) : createLike(_parentKind, parentId);
            case LIKE_KINDS.ARTICLE:
                return isLiked ? deleteLike(_parentKind, parentId) : createLike(_parentKind, parentId);
            case LIKE_KINDS.STATUS:
                return isLiked ? deleteLike(_parentKind, parentId) : createLike(_parentKind, parentId);
            case LIKE_KINDS.COMMENT:
                return isLiked ? deleteCommentLike(_commentKindParent, parentId, commentId) : createCommentLike(_commentKindParent, parentId, commentId);
            case LIKE_KINDS.SUB_COMMENT:
                return isLiked ? deleteSubCommentLike(_commentKindParent, parentId, commentId, subCommentId) : createSubCommentLike(_commentKindParent, parentId, commentId, subCommentId);
            case LIKE_KINDS.TOPIC:
                return isLiked ? deleteTopicLike(parentId) : createTopicLike(parentId);
            case LIKE_KINDS.TOPIC_COMMENT:
                return isLiked ? deleteForumTopicCommentLike(forumId,topicId, parentId) : createForumTopicCommentLike(forumId,topicId, parentId);
            default:
                return null;
        }
    }

    const {
        mutate, isLoading
    } = useMutation(getMutation,{
        onSuccess: handleSuccess,
        onError: handleError
    });

    const {handleLockedAction} = useCurrentUserActionLocked({action : ACTION_LOCKED.CREATE_LIKE, contentOwner});

    function handleLike() {
        if(!isLoading){
            if(canLike){
                setIsLiked(!isLiked);
                mutate(isLiked);
                onMutate();
            }
            else {
                /*switch (currentUser?.role) {
                    case USER_ROLES.EMAIL_UNCONFIRMED:
                        openModal('EmailValidation', {toggle : true, isModal : true});
                        break;
                    default :
                        //openModal('EncourageSignup');
                        navigate(createLink("signin"));
                }*/
                handleLockedAction();
            }
        }
    }

    return {isLiked, handleLike};
}

export default useLike;
export {LIKE_KINDS};